<template>
  <div>
    <div class="right-box">
      <div class="right-title">
        <span>热门公司</span>
      </div>
      <div class="company-box">
        <el-tabs v-model="activeName">
          <el-tab-pane label="影音视频" name="first">
            <div class="company">
              <el-link
                v-for="(list1, index) of list"
                :key="index"
                :href="'/enterprise/#/Inside?name=' + list1"
                target="_blank"
                >{{ list1 }}</el-link
              >
            </div>
          </el-tab-pane>
          <el-tab-pane label="网络直播" name="second">
            <div class="company">
              <el-link
                v-for="(list2, index) of list2"
                :key="index"
                :href="'/enterprise/#/Inside?name=' + list2"
                target="_blank"
                >{{ list2 }}</el-link
              >
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <Email />

    <!-- <div style="width: 365px">
      <a href="https://www.100ec.cn/zt/wswjsxfpgyl/" target="_blank">
        <img style="width: 100%" src="/Public/home/images/zyttk/xfpjr1.jpg" />
      </a>
    </div> -->
    <div style="width: 365px; margin-top: 20px">
      <a>
        <img
          style="width: 100%"
          src="/Public/home/images/zyttk/zytgg/szwyt.jpg?v=1.1"
        />
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContentR",
  data() {
    return {
      activeName: "first",
      list: [
        "爱奇艺",
        "腾讯视频",
        "优酷",
        "哔哩哔哩",
        "芒果TV",
        "网易云音乐",
        "腾讯音乐",
        "阿里音乐",
        "喜马拉雅",
        "蜻蜓FM",
        "荔枝FM",
        "酷狗音乐",
      ],
      list2: [
        "虎牙",
        "斗鱼",
        "YY直播",
        "火猫直播",
        "秀色直播",
        "花椒",
        "KK直播",
        "小草直播",
        "优优直播",
        "映客直播",
        "蜜疯直播",
        "众品直播",
      ],
    };
  },
  // created() {
  //   this.$store.commit("getCompanyTabs", this.params);
  // },
};
</script>